import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getUserRole',
})
export class GetUserRolePipe implements PipeTransform {
  transform(value: any, ..._args: any[]): any {
    if (Array.isArray(value)) {
      const role = value.find((item) => item.name === 'IdentityType');

      if (role && role.value) {
        return role.value;
      }
    }

    return undefined;
  }
}
